module.exports = __webpack_public_path__ + "static/img/consumidor.gov.be0c76b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/common/hotsite/components/footer/consumidor.gov.svg
// module id = 1817
// module chunks = 1